import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'cream' | 'white' | 'charcoal';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'cream',
  id
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-[#F5F0E8]',
    white: 'bg-[#FDFBF7]',
    charcoal: 'bg-[#2D2D2D] text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-131">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">{children}</div>
    </section>;
}